export interface ChangeItem {
  type:
    | "feat"
    | "fix"
    | "docs"
    | "style"
    | "refactor"
    | "test"
    | "chore"
    | "BREAKING CHANGE";
  description: string;
  breaking?: boolean;
}

export interface Version {
  version: string;
  date: string;
  type: "major" | "minor" | "patch";
  changes: ChangeItem[];
  description?: string;
  preRelease?: boolean;
  preReleaseTag?: string;
}

export interface ChangelogData {
  versions: Version[];
  lastUpdated: string;
}

// Default changelog data - this will be auto-generated by the release pipeline
export const changelogData: ChangelogData = {
  lastUpdated: "2026-01-01",
  versions: [
    {
      version: "0.1.0",
      date: "2026-01-01",
      type: "minor",
      description: "Initial release",
      changes: [
        {
          type: "feat",
          description: "Interactive map editor",
        },
        {
          type: "feat",
          description: "Home page and navigation",
        },
        {
          type: "feat",
          description: "Explore page for discovering maps",
        },
        {
          type: "feat",
          description: "User dashboard",
        },
        {
          type: "feat",
          description: "Authentication system",
        },
        {
          type: "feat",
          description: "Responsive design with dark theme support",
        },
      ],
    },
  ],
};

// Helper function to get the latest version
export const getLatestVersion = (): Version => {
  return changelogData.versions[0];
};

// Helper function to get version by tag
export const getVersionByTag = (tag: string): Version | undefined => {
  return changelogData.versions.find((v) => `v${v.version}` === tag);
};

// Helper function to get recent versions
export const getRecentVersions = (count: number = 5): Version[] => {
  return changelogData.versions.slice(0, count);
};

// Helper function to format version type for display
export const formatVersionType = (type: string): string => {
  return type.charAt(0).toUpperCase() + type.slice(1);
};

// Helper function to get change type color
export const getChangeTypeColor = (type: string): string => {
  switch (type) {
    case "feat":
      return "var(--success-color)";
    case "fix":
      return "var(--primary-color)";
    case "docs":
      return "var(--info-color)";
    case "style":
      return "var(--warning-color)";
    case "refactor":
      return "var(--secondary-color)";
    case "test":
      return "var(--info-color)";
    case "chore":
      return "var(--text-secondary-color)";
    case "BREAKING CHANGE":
      return "var(--error-color)";
    default:
      return "var(--text-secondary-color)";
  }
};
